<template>
	<div>
		<CRow>
			<CCol xs="12" lg="12">
				<CCard>
					<CCardHeader>
						<div class="row">
							<CCol sm="6" class="align-self-center">
								<strong>{{ $lang.ai_scholarship_plan.crud.create }}</strong>
							</CCol>
						</div>
					</CCardHeader>
					<CCardBody>
						<CAlert :color="messageColor" closeButton :show.sync="dismissCountDown" fade>
							{{ err_msg }}
						</CAlert>
						<CForm @submit.prevent="onAiScholarshipPlanSubmit">
							<CRow>
								<CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_scholarship_plan.form.title }}<required_span/></label>
										<input type="text" :maxlength="maxlength.title" :placeholder="$lang.ai_scholarship_plan.form.title" class="form-control" v-model="aiScholarshipPlan.title" />
										<small class="error" v-if="$v.aiScholarshipPlan.$error && !$v.aiScholarshipPlan.title.required">{{ $lang.ai_scholarship_plan.validation.required.title }}</small>
									</div>
								</CCol>

								<CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_scholarship_plan.form.type }} <required_span/> </label>
										<v-select id="type" :options="typeOptions" v-model="aiScholarshipPlan.type"></v-select>
										<small class="error" v-if="$v.aiScholarshipPlan.$error && !$v.aiScholarshipPlan.type.required">
                                            {{ $lang.ai_scholarship_plan.validation.required.type }}
                                        </small>
									</div>
								</CCol>

                                <CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_scholarship_plan.form.platform }} <required_span/> </label>
										<v-select id="platform" :options="platformOptions" v-model="aiScholarshipPlan.platform" multiple></v-select>
										<small class="error" v-if="$v.aiScholarshipPlan.$error && !$v.aiScholarshipPlan.platform.required">
                                            {{ $lang.ai_scholarship_plan.validation.required.platform }}
                                        </small>
									</div>
								</CCol>

                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">{{ $lang.ai_scholarship_plan.form.skuCodeAndroid }}</label>
                                        <input type="text" :maxlength="maxlength.skuCode" placeholder="Android SKU Code" class="form-control" v-model="aiScholarshipPlan.skuCodeAndroid" />
                                    </div>
                                </CCol>

                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">{{ $lang.ai_scholarship_plan.form.skuCodeIos }}</label>
                                        <input type="text" :maxlength="maxlength.skuCode" placeholder="iOS SKU Code" class="form-control" v-model="aiScholarshipPlan.skuCodeIos" />
                                    </div>
                                </CCol>

                                <CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_scholarship_plan.form.duration }}</label>
										<v-select id="duration" :options="durationOptions" v-model="aiScholarshipPlan.duration"></v-select>
									</div>
								</CCol>

								<CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_scholarship_plan.form.durationValue }}</label>
										<input type="text" :maxlength="maxlength.durationValue" :placeholder="$lang.ai_scholarship_plan.form.durationValue" class="form-control" v-model="aiScholarshipPlan.durationValue" />
										<small class="error" v-if="$v.aiScholarshipPlan.$error && !$v.aiScholarshipPlan.durationValue.minValue">
                                            {{ $lang.ai_scholarship_plan.validation.required.durationValueMin }}
                                        </small>
										<small class="error" v-if="$v.aiScholarshipPlan.$error && !$v.aiScholarshipPlan.durationValue.maxValue">
                                            {{ $lang.ai_scholarship_plan.validation.required.durationValueMax }}{{ maxV }}
                                        </small>
									</div>
								</CCol>

                                <CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_scholarship_plan.form.credits }}</label>
										<input type="text" :maxlength="maxlength.credits" :placeholder="$lang.ai_scholarship_plan.form.credits" class="form-control" v-model="aiScholarshipPlan.credits" />
									</div>
								</CCol>

                                <CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_scholarship_plan.form.offerCredits }}</label>
										<input type="text" :maxlength="maxlength.offerCredits" :placeholder="$lang.ai_scholarship_plan.form.offerCredits" class="form-control" v-model="aiScholarshipPlan.offerCredits" />
                                        <small class="error" v-if="$v.aiScholarshipPlan.$error && !$v.aiScholarshipPlan.offerCredits.numeric">
                                            Offer Credits must be a valid number
                                        </small>
                                        <small class="error" v-if="$v.aiScholarshipPlan.$error && !$v.aiScholarshipPlan.offerCredits.minValue">
                                            Offer Credits must be greater than or equal to 0
                                        </small>
									</div>
								</CCol>

								<!-- ✅ Is Free Checkbox -->
                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">{{ $lang.ai_scholarship_plan.form.isFree }}</label><br>
                                        <input type="checkbox" :value="0" v-model="aiScholarshipPlan.isFree" @change="changedIsFree" />
                                    </div>
                                </CCol>

								<CCol md="12">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_scholarship_plan.form.description }} <required_span/> </label>
										<textarea :maxlength="maxlength.description" :placeholder="$lang.ai_scholarship_plan.form.description" class="form-control" v-model="aiScholarshipPlan.description" rows="5" />
										<small class="error" v-if="$v.aiScholarshipPlan.$error && !$v.aiScholarshipPlan.description.required">{{ $lang.ai_scholarship_plan.validation.required.description }}</small>
									</div>
								</CCol>
							</CRow>

							<!-- ✅ Hidden when isFree is checked -->
							<span id="plan_pricing">
								<h4>Plan Price</h4>
								<div v-for="(platformInputs, platformKey) in inputs" :key="platformKey">
									<h5 class="mt-3 text-capitalize">{{ platformKey }}</h5>
									<div v-for="input in platformInputs" :key="input.id" class="inputArea">
										<CRow>
											<CCol md="3">
												<div class="form-group">
													<label class="form__label">{{ $lang.ai_scholarship_plan.form.country }} </label>
													<v-select v-model="input.countryId" :options="countryOptions"></v-select>
												</div>
											</CCol>
											<CCol md="3">
												<div class="form-group">
													<label class="form__label">{{ $lang.ai_scholarship_plan.form.price }} </label>
													<input type="text" v-model="input.price" class="form-control" :placeholder="$lang.ai_scholarship_plan.form.price">
												</div>
											</CCol>
											<CCol md="3">
												<div class="form-group">
													<label class="form__label">{{ $lang.ai_scholarship_plan.form.offerPrice }} </label>
													<input type="text" v-model="input.offerPrice" class="form-control" :placeholder="$lang.ai_scholarship_plan.form.offerPrice">
												</div>
											</CCol>
											<CCol md="1">
												<div class="form-group">
													<label class="form__label">Has GST? </label><br>
													<input type="checkbox" v-model="input.hasGst"/>
												</div>
											</CCol>
											<CCol md="2">
												<div class="form-group">
													<label class="form__label">Actions</label><br>
													<button type="button" class="btn btn-success" @click="addInput(platformKey)">
														<i class="fa fa-plus"></i>
													</button>&nbsp;
													<button type="button" class="btn btn-danger" @click="subInput(platformKey, input.id)">
														<i class="fa fa-minus"></i>
													</button>
												</div>
											</CCol>
										</CRow>
									</div>
								</div>
							</span>

							<!-- ✅ Rules Section -->
							<hr>
							<span id="plan_rules">
								<h4>Rules</h4>
								<div class="inputArea" v-for="rule in rules" :key="rule.id">
									<CRow>
										<CCol md="8">
											<div class="form-group">
												<label class="form__label">Rule <required_span /></label>
												<input type="text" placeholder="Rule" class="form-control" v-model="rule.title" />
											</div>
										</CCol>
										<CCol md="2">
											<div class="form-group">
												<label class="form__label">Actions</label><br>
												<button type="button" class="btn btn-success" @click="addRule">
													<i class="fa fa-plus"></i>
												</button>&nbsp;
												<button type="button" class="btn btn-danger" @click="subRule(rule.id)">
													<i class="fa fa-minus"></i>
												</button>
											</div>
										</CCol>
									</CRow>
								</div>
							</span>

                        <CRow>
                            <CCol col="6" class="text-left">
                                <CButton color="primary" :disabled="submitted" class="px-4" type="submit">
                                    {{ $lang.common.general.submit }}
                                </CButton>
                            </CCol>
                        </CRow>
						</CForm>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>

<script>
import $ from "jquery";
import Vue from "vue";
import VueForm from "vue-form";
import { ServerTable } from "vue-tables-2";
import { required, requiredIf } from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import { Maxlength } from "../../store/maxlength";
import { Mixin } from "/src/mixins/index.js";
import store from "/src/store/store.js";
import { country, aiScholarshipPlan } from "/src/store/url.js";
import options from "/src/validations/validations.js";

Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);
export default {
	name: "AiScholarshipPlanCreate",
	mixins: [Mixin],
	components: {
		required_span,
	},
	data() {
		return {
			maxV: '',
			counter: 0,
			ruleCounter: 0,
			menuCounter: 0,
			sideMenuCounter: 0,
			messageColor: "",
			submitted: false,
			err_msg: "",
			showAlert: false,
			dismissCountDown: 0,
			self: this,
			moduleCountry: country,
			module: aiScholarshipPlan,
			msg: "",
			typeOptions: [
				{ 'id': 'Company',         'label': 'Company'          },
				{ 'id': 'DirectCandidate', 'label': 'Direct Candidate' },
			],
			platformOptions: [
				{ 'id': 0, 'label': 'Web'     },
				{ 'id': 1, 'label': 'Android' },
				{ 'id': 2, 'label': 'IOS'     },
			],
            durationOptions: [
				{ 'id': 'Year',  'label': 'Yearly'  },
				{ 'id': 'Month', 'label': 'Monthly' },
				{ 'id': 'Day',   'label': 'Days'    },
			],
			countryOptions: [],
			aiScholarshipPlan: {
				title: "",
				type: "",
                platform: "",
                skuCodeAndroid: "",
                skuCodeIos: "",
                duration: "",
                durationValue: "",
				description: "",
				status: 1,
                credits: "",
                offerCredits: "",
                isFree: false,
			},
            inputs: {
				web:     [{ id: 'web_country0',     price: '', offerPrice: '', hasGst: '', countryId: '' }],
				android: [{ id: 'android_country0', price: '', offerPrice: '', hasGst: '', countryId: '' }],
				ios:     [{ id: 'ios_country0',     price: '', offerPrice: '', hasGst: '', countryId: '' }],
			},
			// ✅ Rules list
			rules: [
				{ id: 'rule0', title: '' },
			],
			maxlength: {
				title:         Maxlength.aiScholarshipPlan.title,
				description:   Maxlength.aiScholarshipPlan.description,
				price:         Maxlength.aiScholarshipPlan.price,
				offerPrice:    Maxlength.aiScholarshipPlan.offerPrice,
                durationValue: Maxlength.aiScholarshipPlan.durationValue,
			},
		};
	},
	validations: {
		aiScholarshipPlan: {
			type:        { required },
			title:       { required },
			description: { required },
			platform:    { required },
            offerCredits: {
                required: requiredIf(function () {
                    return !this.aiScholarshipPlan.isFree;
                }),
                minValue: (value) => {
                    if (value === '' || value === null) return true;
                    return parseFloat(value) >= 0;
                },
                numeric: (value) => {
                    if (value === '' || value === null) return true;
                    return !isNaN(parseFloat(value)) && isFinite(value);
                }
            },
            durationValue: {
				minValue: (function(value) {
					if (value === '') return true;
					return 1 <= value;
				}),
				maxValue: (function(value) {
					let self = this;
					const du = self.aiScholarshipPlan.duration && self.aiScholarshipPlan.duration.id;
					if (du === "Year") {
						if (value <= 9999) return true;
						self.maxV = 9999;
						return false;
					} else if (du === "Month") {
						if (value <= 12) return true;
						self.maxV = 12;
						return false;
					} else {
						if (value <= 365) return true;
						self.maxV = 365;
						return false;
					}
				}),
			}
		},
	},
	mounted() {
		let self = this;
		store.commit("showLoader", false);
		self.dismissCountDown = 0;
		this.$root.$on("alert", (arg1, arg2) => {});
		if (localStorage.getItem("showAlert") !== "") {
			this.setAlert(true);
		}
		this.setAlert(false);
		localStorage.setItem("showAlert", "");
		axios.get('/countries/lists').then((response) => {
			response.data.data.map(function(value, key) {
				self.countryOptions.push({ value: value.id, label: value.name });
			});
		});
	},
	watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (route.query && route.query.page) {
					this.activePage = Number(route.query.page);
				}
			},
		},
	},
	methods: {
        changedIsFree(e) {
            if (e.target.checked) {
                this.aiScholarshipPlan.isFree = true;
                $('#plan_pricing').css('display', 'none');
            } else {
                this.aiScholarshipPlan.isFree = false;
                $('#plan_pricing').css('display', 'block');
            }
        },
		changedHasGST(e) {
			let self = this;
			this.v = e.target.checked;
			if (this.v) {
				self.aiScholarshipPlan.hasGst = 1;
			} else {
				self.aiScholarshipPlan.hasGst = 0;
			}
		},
		addInput(platformKey) {
			this.inputs[platformKey].push({
				id: `${platformKey}_country${this.inputs[platformKey].length}`,
				price: '',
				offerPrice: '',
				hasGst: '',
				countryId: '',
			});
		},
		subInput(platformKey, id) {
			const index = this.inputs[platformKey].findIndex(i => i.id === id);
			if (index > 0) this.inputs[platformKey].splice(index, 1);
		},
		// ✅ Rules methods
		addRule() {
			this.rules.push({
				id: `rule${++this.ruleCounter}`,
				title: '',
			});
		},
		subRule(id) {
			const index = this.rules.findIndex(r => r.id === id);
			if (index !== 0) this.rules.splice(index, 1);
		},
		onAiScholarshipPlanSubmit() {
			let self = this;
			this.$v.aiScholarshipPlan.$touch();
			if (this.$v.aiScholarshipPlan.$invalid) {
				self.submitted = false;
				this.submitStatus = "ERROR";
			} else {
				self.submitted = true;

                const priceDetail = self.aiScholarshipPlan.isFree
                    ? []
                    : Object.keys(this.inputs).flatMap((platformKey) =>
                        this.inputs[platformKey].map((i) => ({
                            platform:        platformKey,
                            countryId:       i.countryId,
                            price:           i.price,
                            offerPrice:      i.offerPrice,
                            isInclusive:     0,
                            gstId:           i.hasGst ? 1 : null,
                            gstBusinessName: i.hasGst ? 'The Resourceful Network Private Limited' : null,
                            gstNumber:       i.hasGst ? '24AAMCT8780H1ZS' : null,
                            hasGst:          i.hasGst ? 1 : 0,
                        }))
                    );

				let postData = {
					"title":          self.aiScholarshipPlan.title,
					"skuCodeAndroid": self.aiScholarshipPlan.skuCodeAndroid,
                    "skuCodeIos":     self.aiScholarshipPlan.skuCodeIos,
					"type":           self.aiScholarshipPlan.type,
					"platform":       self.aiScholarshipPlan.platform,
					"duration":       self.aiScholarshipPlan.duration,
					"durationValue":  self.aiScholarshipPlan.durationValue,
					"credits":        self.aiScholarshipPlan.credits,
					"offerCredits":   self.aiScholarshipPlan.offerCredits,
					"description":    self.aiScholarshipPlan.description,
					"isActive":       self.aiScholarshipPlan.status,
                    "isFree":         self.aiScholarshipPlan.isFree ? 1 : 0,
					"priceDetail":    priceDetail,
					// ✅ Send rules as array of title strings (filter empty)
					"rules":          this.rules.map(r => r.title).filter(r => r !== ""),
				}
                axios.post(this.module.api.create, postData).then((response) => {
                    self.submitted = false;
                    store.commit("showLoader", false);
                    if (response.data.code == 200) {
                        self.err_msg = response.data.message;
                        localStorage.setItem("notificationType", "success");
                        localStorage.setItem("notificationMessage", response.data.message);
                        this.$router.push({ name: "AI Scholarship Plan List" });
                        self.dismissCountDown = 10;
                        self.messageColor = "success";
                    } else {
                        self.err_msg = response.data.message;
                        self.messageColor = "danger";
                        self.dismissCountDown = 10;
                    }
                })
                .catch(function(error) {
                    let data;
                    if (error.response.data.error) {
                        data = error.response.data.error.toString();
                    } else {
                        data = error.response.data.message;
                    }
                    self.err_msg = data;
                    self.dismissCountDown = 10;
                    self.messageColor = "danger";
                    self.submitted = false;
                });
            }
		},
		setAlert(value) {
			this.showAlert = value;
		},
	},
};
</script>

<style>
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	margin-top: 60px;
}
</style>